import { render } from "./program.vue?vue&type=template&id=4c7881e2"
import script from "./program.vue?vue&type=script&lang=js"
export * from "./program.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__